<template>
    <b-modal :visible="value" @change="onInput" :title="title" centered size="xl" @shown="onShown" hide-footer>
        <div style="position: relative;">
            <l-map ref="previewMap" :zoom="defaultZoom" :center="defaultCenter" :style="{ height: mapHeight }" :options="{
                zoomControl: true,
                attributionControl: true
            }">
                <l-tile-layer :url="defaultBaseMap.url" :subdomains="defaultBaseMap.subdomains" />
            </l-map>
            <b-spinner v-if="loading" variant="primary"
                style="position: absolute; right: 12px; bottom: 12px; z-index: 999;" />
        </div>
        <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import API_CONFIG from '@/api-config';
import CONSTANTS from '@/constants';
import parseGeoraster from '@quanghd96/georaster';
import GeoRasterLayer from '@quanghd96/georaster-layer-for-leaflet';

export default {
    name: 'PreviewMapDialog',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Xem bản đồ'
        },
        mapHeight: {
            type: String,
            default: '80vh'
        },
        layerId: {
            type: [String, Number],
            default: null
        },
        fileName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loading: false,
            errorMessage: '',
            previewLayer: null
        };
    },
    computed: {
        defaultBaseMap() {
            return CONSTANTS.BASE_MAP_OPTIONS[0];
        },
        defaultZoom() {
            return 6;
        },
        defaultCenter() {
            return [16.047079, 106.20623];
        }
    },
    watch: {
        value(isVisible) {
            if (!isVisible) this.cleanup();
        },
        fileName() {
            if (this.value) this.loadSelectedFile();
        },
        layerId() {
            if (this.value) this.loadSelectedFile();
        }
    },
    methods: {
        ...mapActions({
            downloadLayerFile: 'mapLayer/downloadFile'
        }),
        onInput(value) {
            this.$emit('input', value);
        },
        onShown() {
            this.$nextTick(() => {
                const map = this.$refs.previewMap && this.$refs.previewMap.mapObject;
                if (!map) return;
                map.invalidateSize();
                map.setView(this.defaultCenter, this.defaultZoom);
                this.loadSelectedFile();
            });
        },
        clearPreviewLayer() {
            const map = this.$refs.previewMap && this.$refs.previewMap.mapObject;
            if (!map || !this.previewLayer) return;
            map.removeLayer(this.previewLayer);
            this.previewLayer = null;
        },
        getFileExt(fileName) {
            if (!fileName || !fileName.includes('.')) return '';
            return fileName.split('.').pop().toLowerCase();
        },
        async loadSelectedFile() {
            const map = this.$refs.previewMap && this.$refs.previewMap.mapObject;
            if (!map || !this.layerId || !this.fileName) return;
            this.loading = true;
            this.errorMessage = '';
            this.clearPreviewLayer();
            try {
                const ext = this.getFileExt(this.fileName);
                if (ext === 'geojson') {
                    const content = await this.downloadLayerFile({
                        id: this.layerId,
                        fileName: this.fileName
                    });
                    this.previewLayer = L.geoJSON(content, {
                        style: {
                            color: '#ff7800',
                            weight: 1
                        }
                    });
                    this.previewLayer.addTo(map);
                } else if (ext === 'tif' || ext === 'tiff') {
                    const georaster = await parseGeoraster(
                        `${API_CONFIG.BASE_URL}map-layer/${this.layerId}/download-file?fileName=${this.fileName}`
                    );
                    this.previewLayer = new GeoRasterLayer({
                        georaster,
                        caching: false,
                        opacity: 0.7,
                        resolution: 256,
                        zIndex: 600,
                        resampleMethod: 'nearest'
                    });
                    this.previewLayer.addTo(map);
                } else {
                    this.errorMessage = 'Định dạng file chưa được hỗ trợ để xem trước';
                    return;
                }
            } catch (error) {
                this.errorMessage = 'Không thể tải hoặc hiển thị file bản đồ';
            } finally {
                this.loading = false;
            }
        },
        cleanup() {
            this.clearPreviewLayer();
            this.loading = false;
            this.errorMessage = '';
        }
    },
    beforeDestroy() {
        this.cleanup();
    }
};
</script>
